import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/HomeView.vue') },
  { path: '/products', name: 'Products', component: () => import('../views/ProductsView.vue') },
  { path: '/products/:id', name: 'ProductDetail', component: () => import('../views/ProductDetailView.vue') },
  { path: '/about', name: 'About', component: () => import('../views/AboutView.vue') },
  { path: '/bases', name: 'Bases', component: () => import('../views/BasesView.vue') },
  { path: '/quality', name: 'Quality', component: () => import('../views/QualityView.vue') },
  { path: '/news', name: 'News', component: () => import('../views/NewsView.vue') },
  { path: '/contact', name: 'Contact', component: () => import('../views/ContactView.vue') },
  { path: '/game', name: 'Game', component: () => import('../views/GameView.vue') }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() { return { top: 0 } }
})

export default router
